import React from 'react';
import { Helmet } from 'react-helmet-async';
import SliderHome from '../components/sections/Home/SliderHome';
import UnoHome from '../components/sections/Home/UnoHome';
import FormularioContactoHome from '../components/sections/Home/FormularioContactoHome';
import Header from '../components/layouts/Header'; 
import Footer from '../components/layouts/Footer';

const Home = () => {
  return (
    <div>
      <Helmet>
        <title>Inicio | Decototal</title>
         <meta name="description" content="Decototal comercializadora, consulta nuestro catálogo, tenemos entrega inmediata." />
         <meta name="keywords" content="Decototal comercializadora, Cotización Deco Total, Decototal, Pisos" />
         <link rel="canonical" href="https://decototal.com.mx/" />
         <meta property="og:title" content="Sitio Oficial Decototal" />
         <meta property="og:description" content="Decototal Comercializadora, Escríbenos y obtén información personalizada." />
         <meta property="og:image" content="URL-de-tu-imagen.jpg" />
         <meta property="og:url" content="https://decototal.com.mx/" />
      </Helmet>
      <Header />
      <SliderHome /> 
      <UnoHome />
      <FormularioContactoHome />
      <Footer /> 
    </div>
  );
};

export default Home;
